import { Component, h } from 'preact'
import { FilterSelectorComponent, FilterSelectorState } from './interfaces'
import InputGroup from '../../ui-components/InputGroup'
import DatePicker from '../../date-picker'

class DateFilterSelector extends Component<FilterSelectorComponent, FilterSelectorState> {
  constructor (props: FilterSelectorComponent) {
    super(props)
    this.state = {
      condition: props.selectedFilterItems?.condition || '',
      data: props.selectedFilterItems?.data || '',
      type: props.selectedFilterItems?.type || '',
      unit: props.selectedFilterItems?.unit || ''
    }
  }

  setCondition = (condition: string, itemType: string) => {
    const { data, type } = this.state
    const alreadyAppliedFilter = this.props.selectedFilterItems[0]

    const newData = type === itemType ? data : alreadyAppliedFilter?.type === itemType ? alreadyAppliedFilter?.data : ''

    this.setState({ condition, data: newData, type: itemType })
  }

  setData = (data: string | number, item: any) => {
    const { condition } = this.state
    this.setState({ condition, data, unit: item.type === 'relative' && item.unit })
  }

  getSubInputTitle = (itemUnit: string) => {
    return `${itemUnit}s ago`
  }

  shouldShowCalendar = (item: any) => {
    return item.type === 'absolute'
  }

  render ({ name, items, selectedFilterItems, children } : FilterSelectorComponent, { condition, data, type }: FilterSelectorState) {
    return <div>
      <div className='overview__filters-box-content'>
        {items.map(item => {
          const checked = condition === item.value && type === item.type
          return <div>
            <InputGroup
              inline
              key={item.id}
              name={name}
              value={item.value}
              title={item.name}
              type='radio'
              formGroupClasses='overview__filters-box-filter'
              checked={checked}
              onChange={(e) => this.setCondition(e.target.value, item.type)} />
            { checked
              ? this.shouldShowCalendar(item)
                ? <DatePicker
                  isBrand
                  disableInput
                  allowPastDates
                  value={data ? new Date(data) : undefined}
                  onChange={(dates: Date[]) => this.setData(dates[0].toISOString(), item)}
                />
                : <InputGroup
                  inline
                  name={name}
                  value={data}
                  title={this.getSubInputTitle(item.unit)}
                  type='number'
                  min={0}
                  formGroupClasses='overview__filters-data-input'
                  onKeyUp={(e) => this.setData(e.target.value, item)}
                  onChange={(e) => this.setData(e.target.value, item)}
                /> : null }
          </div>
        })}
      </div>
      { children[0]({
        data: { ...this.state },
        isApplyButtonDisabled: !condition || !data
      }) }
    </div>
  }
}

export default DateFilterSelector
